/* eslint-disable max-len */
/**
 * @file 工具路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

import perms from '@/common/permissions/sale/perms';
import { isOa } from '@/utils';
import { ACCOUNT_TYPE, AD_PLATFORM_TYPE_NAME } from '@/constants/Constants';
import { ROLES_NAME_TO_ID } from '@/pages/agency/permission-config';

export default [
  {
    label: '工具',
    key: 'manage_toolbox',
    desc: '商务管家、客户拓展查询工具、腾讯营销如翼、极速开户工具、营销学堂、子客迁移工具、操作日志和登录微信号修改等工具的统一入口',
    href: '/agency/manage/toolbox',
    // perm: () => !isOa(),
    data: [
      {
        label: '工具',
        href: '/agency/manage/toolbox',
        hide: true,
        data: [
          {
            label: '工具',
            key: 'manage_toolbox',
            desc: '商务管家、客户拓展查询工具、腾讯营销如翼、极速开户工具、营销学堂、子客迁移工具、操作日志和登录微信号修改等工具的统一入口',
            href: '/agency/manage/toolbox',
            hide: true,
            perm: () => !isOa(),
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
        ],
      },
      {
        label: '帐号工具',
        disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
        perm: () => !isOa(),
        data: [
          {
            id: 'transfer',
            label: '子客迁移',
            desc: '支持服务商下的子客帐号迁移至其他服务商帐号',
            href: '/agency/manage/transfer/relationship',
            path: '/agency/manage/transfer/:type',
            key: 'manage-transfer',
            purview: 22010,
            singleTabNav: true,
            data: [
              {
                id: 'transfer-relationship',
                label: '子客迁移',
                href: '/agency/manage/transfer/relationship',
                platform: [AD_PLATFORM_TYPE_NAME.ADQ, AD_PLATFORM_TYPE_NAME.CPS],
                purview: 22010,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/transfer/Layout'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
              {
                id: 'transfer-record',
                label: '迁移记录',
                href: '/agency/manage/transfer/record',
                platform: [AD_PLATFORM_TYPE_NAME.ADQ, AD_PLATFORM_TYPE_NAME.CPS],
                purview: 22010,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/transfer/Layout'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
            ],
          },
          {
            id: 'fca',
            label: '极速开户',
            desc: '输入帐号ID，勾选复用帐号信息，无需审核即可开户',
            href: '/agency/manage/toolbox/fca',
            key: 'manage-fca',
            platform: AD_PLATFORM_TYPE_NAME.ADQ,
            purview: 22008,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'customerquery',
            label: '客户拓展查询',
            desc: '帮助服务商便捷查询子客的框架归属、对应补贴等信息的重要工具',
            href: '/agency/manage/customerquery',
            key: 'manage-customerquery',
            platform: [AD_PLATFORM_TYPE_NAME.ADQ, AD_PLATFORM_TYPE_NAME.CPS],
            purview: 22000,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/customerquery/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'paymentcertification',
            label: '身份验证',
            desc: '客户完成身份验证后才可给账户充值和进行对外转账',
            href: '/agency/payment-certification',
            key: 'manage-payment-certification',
            purview: 22013,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/paymentCertification/agency-entry'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'queryCustomer',
            label: '子客违规查询',
            desc: '支持服务商下的子客违规查询和数据下载',
            href: '/agency/manage/punishment/list',
            path: '/agency/manage/punishment/:type',
            key: 'manage-queryCustomer',
            purview: 125,
            singleTabNav: true,
            data: [
              {
                id: 'punishment-list',
                label: '子客违规查询',
                href: '/agency/manage/punishment/list',
                purview: 125,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/punishment-list'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
              {
                id: 'punishment-appeal',
                label: '申诉单据查询',
                href: '/agency/manage/punishment/appeal',
                purview: 125,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/punishment-appeal'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
            ],
          },
          {
            id: 'novermarking',
            href: '/agency/manage/novermarking',
            purview: 99,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/novermarking/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'risk-file',
            label: '主体风控档案',
            href: '/agency/manage/risk-file',
            perm: (loginStatus: Record<string, any>) => {
              return loginStatus.privilege_list[137] || loginStatus.privilege_list[139];
            },
            enableKey: 'enable_risk_control_reporting',
            component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/risk-file'), { fallback: <Loading /> }),
            basePage: true,
            singleTabNav: true,
            showSideNav: false,
          },
          {
            id: 'pollingcheck',
            label: '账户巡检记录',
            desc: '支持查询服务商下账户的巡查记录',
            href: '/agency/polling/check/preview',
            path: '/agency/polling/check/:type',
            key: 'polling-check',
            perm: (loginStatus: Record<string, any>) => {
              // loginStatus.login_type === 3 代表免登陆
              // return (+loginStatus.login_type === 3 || +loginStatus.login_type === 4);
              // return +loginStatus.login_type === 3;
              // return true
              return loginStatus.privilege_list[135] || loginStatus.privilege_list[134] || loginStatus.login_type === 3; // 134-账户巡查记录查看 135-查看全部账户巡查数据
            },
            data: [
              {
                id: 'check-preview',
                label: '开户预审',
                href: '/agency/polling/check/preview',
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/pollingCheck/preview'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
              {
                id: 'check-backlink',
                label: '素材&在投&后链路巡查',
                href: '/agency/polling/check/backlink',
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/pollingCheck/backlink'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
            ],
          },
          {
            id: 'prompt-tools',
            label: 'prompt工具',
            href: '/agency/manage/prompt-tools',
            key: 'prompt-tools',
            enableKey: 'is_prompt_collect_enable',
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/prompt-tools/modules/index'), { fallback: <Loading /> }),
            basePage: true,
            desc: '人工经验收集',
            showSideNav: false,
          },
        ],
      },
      {
        label: '合作平台',
        perm: () => !isOa(),
        data: [
          {
            id: 'bm',
            label: '商务管家',
            desc: '帮助客户便捷、高效管理多营销帐号的重要工具',
            href: '/agency/manage/bm',
            key: 'manage-bm',
            purview: 22005,
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/bm/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'edu',
            label: '营销学堂',
            desc: '综合的培训平台。包括：线上自助课程、从业资格认证、以及线上线下多种学习方式',
            href: '/agency/manage/toolbox/edu',
            key: 'manage-edu',
            purview: 101,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'dmp',
            label: '腾讯营销如翼',
            desc: '腾讯营销如翼连接用户数据和投放数据，提升投放效果',
            href: '/agency/manage/toolbox/dmp',
            key: 'manage-dmp',
            purview: 107,
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'adx',
            label: '程序化营销交易平台',
            desc: '提供程序化交易场景中，面向DSP的运营数据分析及业务配置能力',
            href: '/agency/manage/toolbox/adx',
            key: 'manage-adx',
            purview: 22009,
            perm: (loginStatus: Record<string, any>) => (_.find(loginStatus.agency_list, (v) => v.agency_uid === loginStatus.agency_uid) || {}).is_adx,
            enableKey: 'is_jump_adx_enable',
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'bond',
            label: '保证金帐号管理',
            desc: '为同一主体资质下保证金业务相关帐号进行管理',
            href: '/agency/manage/toolbox/bond',
            key: 'manage-bond',
            purview: 22012,
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'admaster',
            label: '智能投手',
            desc: '便捷完成营销单元的批量创建及一键托管，提升投放效率',
            href: '/agency/manage/toolbox/admaster',
            key: 'manage-admaster',
            purview: 109,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
        ],
      },
      {
        label: '辅助管理',
        data: [
          {
            id: 'modify_wechat',
            label: '修改登录微信号',
            desc: '当登录微信号发生变更时，可在此处修改微信号',
            href: '/agency/manage/modify-wechat-number',
            key: 'manage-modify-wechat-number',
            purview: 115,
            perm: (loginStatus: Record<string, any>) => !isOa() && loginStatus.wechat_number,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/modify-wechat/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'operation_log',
            label: '操作日志',
            desc: '员工信息、客户信息等核心内容的变更记录',
            href: '/agency/manage/operation-log',
            key: 'manage-operation-log',
            purview: 22011,
            perm: () => !isOa(),
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/operation-log/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'operation_log',
            label: '操作日志', // 操作日志 oa 域内查看
            desc: '员工信息、客户信息等核心内容的变更记录',
            href: '/agency/manage/operation-log-oa',
            perm: () => isOa(),
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/operation-log/Layout'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'bid',
            label: '竞争性评估管理',
            desc: '申请竞争性评估报名入口，可供服务商提交相关资料以及查询评估状态',
            href: '/agency/manage/bid/apply',
            path: '/agency/manage/bid/:type',
            key: 'manage-bid',
            perm: (loginStatus: Record<string, any>) => !isOa() && (loginStatus.role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_ADMIN] || loginStatus.role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_BOSS]),
            disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            singleTabNav: true,
            data: [
              {
                id: 'bid-apply',
                label: '申请报名',
                href: '/agency/manage/bid/apply',
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/bid/apply'), { fallback: <Loading /> }),
                // singleTabNav: true,
                basePage: true,
                showSideNav: false,
              },
              {
                id: 'bid-record',
                label: '申请记录',
                href: '/agency/manage/bid/record',
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/bid/record'), { fallback: <Loading /> }),
                // singleTabNav: true,
                basePage: true,
                showSideNav: false,
              },
            ],
          },
          {
            id: 'customer_bid',
            label: '客户招标管理',
            desc: '客户招标管理记录',
            href: '/agency/manage/customer-bid',
            purview: 8238902,
            perm: () => !isOa(),
            // disabled: (loginStatus: Record<string, any>) => loginStatus.account_type === ACCOUNT_TYPE.direct,
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/participate-bid/index'), { fallback: <Loading /> }),
            singleTabNav: true,
            basePage: true,
            showSideNav: false,
          },
          {
            id: 'merge_user_id',
            label: '合并员工ID',
            desc: '若一个员工有多个员工ID，则可以在此处合并员工ID',
            href: '/agency/manage/user-id/merge',
            path: '/agency/manage/user-id/:type',
            key: 'manage-user-id',
            perm: (loginStatus: Record<string, any>) => {
              if (!!loginStatus?.feature_flag?.is_enable_strict_employee_rule) {
                return true;
              }
              return false;
            },
            purview: 116,
            disabled: (loginStatus: Record<string, any>) => !isOa() && loginStatus.account_type === ACCOUNT_TYPE.direct,
            singleTabNav: true,
            data: [
              {
                id: 'merge',
                label: '合并员工ID',
                href: '/agency/manage/user-id/merge',
                purview: 116,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/userId/merge'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
              // {
              //   id: 'merge_record',
              //   label: '合并记录',
              //   href: '/agency/manage/user-id/record',
              //   purview: 116,
              //   component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/userId/record'), { fallback: <Loading /> }),
              //   singleTabNav: true,
              //   basePage: true,
              // },
              {
                id: 'merge_record',
                label: '合并记录',
                href: '/agency/manage/user-id/record',
                purview: 116,
                component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/userId/newRecord'), { fallback: <Loading /> }),
                basePage: true,
                showSideNav: false,
              },
            ],
          },
          {
            id: 'unbundle-qualification',
            label: '注册资质解绑',
            desc: '当前操作会解绑员工ID关联的注册资质，请谨慎操作',
            href: '/tool/unbundle',
            path: '/tool/unbundle',
            key: 'unbundle-qualification',
            perm: (loginStatus: Record<string, any>) => {
              if (!!loginStatus?.feature_flag?.is_enable_strict_employee_rule
                && (loginStatus.role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_ADMIN]
                  || loginStatus.role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_BOSS]
                  || loginStatus.role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_SUB_ADMIN])
              ) {
                return true;
              }
              return false;
            },
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/tool/unbundle-qualification'), { fallback: <Loading /> }),
            singleTabNav: true,
            isMicroApp: true,
            basePage: true,
            showSideNav: false,
          },
        ],
      },
      {
        label: '销售管理',
        href: '/agency/manage/toolbox',
        perm: () => !isOa(),
        component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
        data: [
          {
            id: 'tagsync',
            label: '企业标签同步',
            desc: '依据“企微标签管理”的映射规则进行线索至企微客户的映射',
            href: '/agency/manage/toolbox/tagsync',
            key: 'manage-tagsync',
            perm: (loginStatus: Record<string, any>) => _.includes(loginStatus.saleStatus?.grayPermissions, perms.GRAY_ONLINE_SALES_AGENCY_BIND) && loginStatus.oneOf([perms.ONLINE_SALES_TOOL_TAG_MANAGER]),
            component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/toolbox/Layout'), { fallback: <Loading /> }),
            hideTabNav: true,
            basePage: true,
            showSideNav: false,
          },
        ],
      },
      {
        key: 'mkt',
        label: '营销服务市场',
        desc: '聚合优质三方生态服务和工具，提供营销全链路工具方案',
        perm: () => !isOa(),
        purview: 117,
        data: [
          {
            id: 'mkt_add',
            label: '添加更多应用',
            desc: '聚合优质三方生态服务和工具，提供营销全链路工具方案',
            href: 'https://isv.e.qq.com?from=amshomesgj',
            key: 'manage-mkt-add',
            target: '_blank',
            purview: 117,
            useNavOpenReport: true,
            navOpenReportParams: {
              page2: '营销服务市场',
            },
            showSideNav: false,
          },
        ],
      },
      {
        label: '校验员工ID',
        href: '/tool/check-userid',
        key: 'check_userid',
        perm: () => !isOa(),
        component: loadable(() => import(/* webpackChunkName: 'toolbox' */ /* webpackMode: 'lazy' */ '@/pages/tool/check-userid'), { fallback: <Loading /> }),
        hide: true,
        purview: 118,
        showSideNav: false,
      },
    ],
  },
];
